import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { FunctionService, ThemeService } from 'vhobjects-service';
import { ColorContrastComponent } from '../../../../color-contrast/color-contrast.component';

@Component({
  selector: 'atw-btn-booking-config',
  templateUrl: './btn-booking-config.component.html',
  styleUrls: ['./btn-booking-config.component.scss'],
})
export class AtwBtnBookingConfig implements OnInit {
  @Input() objectChoosing: any;
  @Input() device: any;
  @Input() class: any;
  @Input() config: any;
  @Input() staticdata: any;
  @Input() type: any;

  isCollapsed: boolean = false;
  isOpen: boolean = false; // trạng thái mở/đóng popup, dùng cho nz-switch
  currentViewAll: any = {};
  isViewAll: boolean = false;
  id_subproject: any;
  arr_link_page: any;
  valueRange: number = 0;
  valueParameter: number = 0;
  style_color: string = '';
  isOpenOptionsBorder: boolean = false;
  fonts = [];
  backgroundColor: any = [];
  effect_hover: any = [];
  effect_hover_data: any = {};
  customize = [];
  block_modal = []; // danh sách block dạng hover_blank để chọn cho popup/drawer
  devicePosition: any = {};
  detailblock: any = {};
  subproject: any;
  width = 0;
  height = 0;

  parentComponent: string = '';

  typeGradient = [
    { type: 'linear-gradient', direction: '', name: 'mac_dinh', deg: '180deg' },
    { type: 'linear-gradient', direction: 'to top,', name: 'tu_duoi_len_tren', deg: '0deg' },
    { type: 'linear-gradient', direction: 'to right,', name: 'tu_trai_sang_phai', deg: '90deg' },
    { type: 'linear-gradient', direction: 'to left,', name: 'tu_phai_sang_trai', deg: '270deg' },
    { type: 'linear-gradient', direction: 'to bottom right,', name: 'tu_trai_tren_sang_phai_duoi', deg: '135deg' },
    { type: 'linear-gradient', direction: 'to bottom left,', name: 'tu_phai_tren_sang_trai_duoi', deg: '225deg' },
    { type: 'linear-gradient', direction: 'to top right,', name: 'tu_trai_duoi_sang_phai_tren', deg: '45deg' },
    { type: 'linear-gradient', direction: 'to top left,', name: 'tu_phai_duoi_sang_trai_tren', deg: '315deg' },
  ];

  styles_field = [
    { title: 'dieu_chinh_noi_dung', index: 1 },
    { title: 'dieu_chinh_vien_nut_bam', index: 2 },
    { title: 'hieu_ung_chuyen_dong', index: 3 },
    { title: 'nang_cao', index: 4 },
  ];

  /** Options for selecting which link to pass as param */
  linkParamTypeOptions = [
    { value: 'room_type_link', label: 'loai_phong' },
    { value: 'hotel_product_link', label: 'khach_san' },
  ];

  /** đọc actionType 1 lần cho gọn template, giống bên component runtime AtwBtnBooking */
  get actionType(): 'link' | 'drawer' {
    return this.config?.['type_show_block'] || 'link';
  }

  /** Check if parent is AtwFrameRoom or AtwFrameRoomByHotel */
  get isRoomTypeFrame(): boolean {
    return this.parentComponent === 'AtwFrameRoom' || this.parentComponent === 'AtwFrameRoomByHotel';
  }

  private isAutoTranslate: boolean;

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    public themeService: ThemeService,
    private matDialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language')?.auto_translate_language;
      });

    this.subproject = this.vhQueryAutoWeb.getlocalSubProject(
      this.vhQueryAutoWeb.getlocalSubProject_Working()._id
    );

    forkJoin([
      this.http.get('assets/data/effects/button.json'),
      this.http.get('assets/background-colors/background-colors.json'),
      this.http.get('assets/fonts/fonts.json'),
    ]).subscribe(([effects, background_colors, fonts]: any) => {
      this.fonts = fonts;
      this.effect_hover = effects;
      this.backgroundColor = background_colors;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    });

    this.getBlockClick();
    this.getDetailBlock();

    // Fetch parent object to check its component type
    this.vhQueryAutoWeb.getObject(this.objectChoosing.id_object).then((object: any) => {
      if (object) {
        this.parentComponent = object.component;
        if (this.isRoomTypeFrame) {
          this.staticdata.link_param_type ??= 'hotel_product_link';
        }
      }
    });
  }

  ngOnChanges({ device }: SimpleChanges): void {
    this.staticdata.accessibility ??= {};

    // dữ liệu cũ trong DB có thể chưa có các key này (object mới AtwBtnBooking) -> khởi tạo mặc định để tránh lỗi binding
    this.class['button'] ??= {};
    this.class['button__content'] ??= {};
    this.class['button__content--icon-wrapper'] ??= {};
    this.class['button__content--icon'] ??= {};
    this.class['btn-modal__drawer'] ??= {};
    this.class['btn-modal__drawer--icon'] ??= {};
    this.class['btn-modal__popup-icon'] ??= {};

    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }

    this.width = document.getElementById(this.objectChoosing._id)?.clientWidth || 0;
    this.height = document.getElementById(this.objectChoosing._id)?.clientHeight || 0;
  }

  /**
   * Lấy danh sách block dạng hover_blank để đổ vào mat-select "chọn khối hiển thị"
   */
  getBlockClick() {
    this.vhQueryAutoWeb.getBlocks_byFields({ type: { $eq: 'hover_blank' } })
      .then((blocks: any) => {
        this.block_modal = blocks;
      });
  }

  /**
   * Lấy chi tiết block đang được chọn làm nội dung popup/drawer
   */
  getDetailBlock() {
    if (!this.staticdata.id_freeblock) return;
    this.vhQueryAutoWeb.getDetailBlock(this.staticdata.id_freeblock).then(
      (detailblock) => { if (detailblock) this.detailblock = detailblock; },
      (error) => { }
    );
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.config['background-color'].gradient_check) {
      this.class['button']['background-image'] = 'linear-gradient(' + this.config['background-color']['gradient_direction'] + this.config['background-color']['gradient_arr'] + ')';
    } else {
      this.class['button']['background-image'] = 'none';
    }
    this.updateObject();
  }

  /** Hàm update object vào database. */
  updateObject() {
    return this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      [this.device + '_class']: this.class,
      [this.device + '_config']: this.config,
      staticdata: this.staticdata,
    }).then((bool: any) => { });
  }

  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => { });
  }

  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => { });
  }

  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => { });
    this.updateDimension();
  }

  updateDimension() {
    this.width = document.getElementById(this.objectChoosing._id)?.clientWidth || 0;
    this.height = document.getElementById(this.objectChoosing._id)?.clientHeight || 0;
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.config = {
      ...this.config,
      dimension: {
        width: Number(Number(this.width).toFixed(2)),
        height: Number(Number(this.height).toFixed(2)),
      },
    };
    this.updateConfig();
  }

  updateClassAndWidthHeight() {
    this.width = document.getElementById(this.objectChoosing._id)?.clientWidth || 0;
    this.height = document.getElementById(this.objectChoosing._id)?.clientHeight || 0;
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass();
  }

  removeLink() {
    this.staticdata.hyper_link = '';
    this.updateStaticData();
  }

  hexToRGB(hex: string): string {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `${r}, ${g}, ${b}`;
  }

  getValueRangeBackgroundColor(e) {
    this.valueParameter = e.target.value;
    const data = this.class['button'];
    this.style_color = `rgba(${this.hexToRGB(data.background)}, ${this.config['background-color']['value_range'] / 100})`;
    data.background_rgb = this.style_color;
    this.updateClass();
  }

  getValueRangeBackgroundGradient(e) {
    this.valueParameter = e.target.value;
    this.config['background-color']['value_parameter'] = this.valueParameter;
    this.config['background-color']['value_range'] = this.valueParameter / 100;
    const newArr = this.config['background-color'].gradient_arr.map((color) => {
      const parts = color.match(/(\d+(\.\d+)?)/g);
      return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-color']['value_range']})`;
    });
    this.config['background-color'].gradient_arr = newArr;
    this.device == 'desktop' ? this.updateBackgroundRgb() : this.updateClass();
  }

  updateColorInput(e) {
    const value_color = e.target.value;
    const data = this.class['button'];
    this.style_color = `rgba(${this.hexToRGB(value_color)}, ${this.config['background-color']['value_range']})`;
    data.background_rgb = this.style_color;
    this.updateClass();
  }

  chooseBg(bgColor, event) {
    var activeGradient = document.querySelector('.container-color .active') as HTMLElement;
    if (activeGradient) activeGradient.classList.remove('active');
    event.currentTarget.classList.add('active');

    const data_background = this.class['button'];
    data_background['background-color'] = bgColor.bgColor;
    data_background['background-color'] = `rgba(${this.hexToRGB(data_background['background-color'])}, ${this.config['background-color'].value_range})`;
    this.updateObject();
  }

  chooseOption(direction, event) {
    var activeGradient = document.querySelector('.active') as HTMLElement;
    if (activeGradient) activeGradient.classList.remove('active');
    event.currentTarget.classList.add('active');

    this.config['background-color'].gradient_type = direction.type;
    this.config['background-color'].gradient_direction = direction.direction;
    this.class['button']['background'] = this.config['background-color'].gradient_type + '(' + this.config['background-color'].gradient_direction + this.config['background-color'].gradient_arr.join(',') + ')';
    this.updateConfig();
    this.updateClass();
  }

  toggleBorder(isActive) {
    const active = this.class['button'];
    active.check_border = isActive;
    active.check_border_top = isActive;
    active.check_border_bottom = isActive;
    active.check_border_right = isActive;
    active.check_border_left = isActive;
    this.updateClass();
  }

  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient = this.config['background-color'];
      gradient['gradient_arr'].push(`rgba(${this.hexToRGB(value)}, ${gradient.value_range})`);
      this.updateBackgroundRgb();
    }
  }

  deleteGradient(index) {
    if (this.config['background-color']['gradient_arr'].length > 1) {
      this.config['background-color']['gradient_arr'].splice(index, 1);
      this.updateBackgroundRgb();
    }
  }

  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  openMap: { [name: string]: boolean } = {
    menu1: true, menu2: false, menu3: false, menu4: false, menu5: false,
    menu6: false, menu7: false, menu8: false, menu9: false,
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) this.openMap[key] = false;
    }
  }

  changeWidthHeight(event) {
    if (event.width) {
      this.class['button']['padding-left'] = Number(this.class['button']['padding-left'].toString().match(/\d+(\.\d+)?/g).join('')) + (event.width - this.width) / 2 + 'px';
      this.class['button']['padding-right'] = Number(this.class['button']['padding-right'].toString().match(/\d+(\.\d+)?/g).join('')) + (event.width - this.width) / 2 + 'px';
    }
    if (event.height) {
      this.class['button']['padding-top'] = Number(this.class['button']['padding-top'].toString().match(/\d+(\.\d+)?/g).join('')) + (event.height - this.height) / 2 + 'px';
      this.class['button']['padding-bottom'] = Number(this.class['button']['padding-bottom'].toString().match(/\d+(\.\d+)?/g).join('')) + (event.height - this.height) / 2 + 'px';
    }
    this.updateClassAndWidthHeight();
  }

  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[2]);
  }

  openColorContrast() {
    const colorClass = this.class['button__content'].color ? 'button__content' : 'button';
    const dialogRef = this.matDialog.open(ColorContrastComponent, {
      width: '30vw',
      height: 'fit-content',
      data: {
        colorContrast: {
          typeFgColor: 'text',
          textOrIconColor: this.class[colorClass].color,
          bgColor: this.class['button']['background-color'],
        },
      },
    });

    dialogRef.afterClosed().subscribe((colorContrast) => {
      if (colorContrast) {
        this.class[colorClass].color = colorContrast.textOrIconColor;
        this.class['button']['background-color'] = colorContrast.bgColor;
        this.updateClass();
      }
    });
  }


  /**
   * Bắt sự kiện đổi hướng xuất hiện của drawer
   */
  handlePositionDrawer(align) {
    switch (align) {
      case 'top': this.config['block_position'] = 'top'; break;
      case 'bottom': this.config['block_position'] = 'bottom'; break;
      case 'left': this.config['block_position'] = 'left'; break;
      case 'right': this.config['block_position'] = 'right'; break;
    }
    this.updateObject();
  }

  /**
   * Xử lý sự kiện đóng mở hộp thoại từ panel config (preview trong lúc thiết kế)
   */
  handleShowDialog(isOpen: boolean) {
    if (this.actionType == 'drawer') {
      this.vhEventMediator.notifyOnConfigChanged({ status: 'open-drawer', code: this.objectChoosing._id });
    }
  }

  updateContent(fieldContent, isAriaLabel = false) {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        isAriaLabel
          ? this.staticdata.accessibility?.[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
          : this.staticdata[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
      ).subscribe({
        next: (data) => {
          this.functionService.multi_languages.forEach(lang => {
            if (!isAriaLabel) {
              if (this.functionService.selectedLanguageCode != lang.code && !this.staticdata[`${fieldContent}_${lang.code}`]) {
                this.staticdata[`${fieldContent}_${lang.code}`] = data.find(item => item.langCode == lang.code).translatedText;
              }
            } else {
              if (this.functionService.selectedLanguageCode != lang.code && !this.staticdata.accessibility?.[`${fieldContent}_${lang.code}`]) {
                this.staticdata.accessibility[`${fieldContent}_${lang.code}`] = data.find(item => item.langCode == lang.code).translatedText;
              }
            }
          });
          this.updateStaticData();
        },
        error: (err) => { console.error('Lỗi dịch thuật:', err); },
      });
    } else {
      this.updateStaticData();
    }
  }

  private readonly iconClassKeys = ['btn-modal__drawer--icon', 'btn-modal__popup-icon'];

  updateIconProp(prop: string, value: any, shouldPersist: boolean = true) {
    this.iconClassKeys.forEach((key) => {
      this.class[key] ??= {};
      this.class[key][prop] = value;
    });
    if (shouldPersist) this.updateClass();
  }
}